<template>
  <div class="wrapper landing-page">
    <div class="page-header page-header-small">
      <parallax class="page-header-image" style="background-image: url('img/bg32.jpg')"></parallax>
      <div class="content-center">
        <h1 class="title">Nuestras oficinas</h1>
       <!-- <div class="text-center">
          <a href="#pablo" class="btn btn-primary btn-icon btn-round">
            <i class="fab fa-facebook-square"></i>
          </a>
          <a href="#pablo" class="btn btn-primary btn-icon btn-round">
            <i class="fab fa-twitter"></i>
          </a>
          <a href="#pablo" class="btn btn-primary btn-icon btn-round">
            <i class="fab fa-google-plus"></i>
          </a>
        </div>
        -->
      </div>
    </div>
   
        <div class="row">
          <div class="col-md-8 ml-auto mr-auto text-center">
            <h2 class="title">¿Dónde nos encontramos?</h2>
          </div>
         </div>
       <div class="card">

      <div class="card-body row">
        <div class="col-12">
           <el-table
         
            :data="tableData"
            header-row-class-name="text-primary"
            v-show="!isMobile()"
          >
          
            <el-table-column prop="SeccionalNombre" label="Seccional" min-width="240px"></el-table-column>
           
            <el-table-column prop="SeccionalDomicilio" min-width="380px" label="Dirección"></el-table-column>
           
            <el-table-column prop="SeccionalTelefono" min-width="380px" label="Teléfono"></el-table-column>
              <el-table-column prop="SeccionalEmail" min-width="380px" label="Email"></el-table-column>
          </el-table>

          <!-- Mobile table -->
           <el-table
          
            :data="tableData"
            header-row-class-name="text-primary"
             v-show="isMobile()">
            <el-table-column prop="SeccionalNombre" label="Seccional">
            <template slot-scope="scope">
                <p>
                  <b>{{ scope.row.SeccionalNombre }}</b>
                </p>
                <p>
                  <b>Dirección:</b>
                  {{ scope.row.SeccionalDomicilio }}
                </p>
                <p>
                  <b>Teléfono:</b>
                  {{ scope.row.SeccionalTelefono}}
                </p>
                <p>
                  <b>Email:</b>
                  {{scope.row.SeccionalEmail}}
                </p>
               
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
    </div>
    <div class="section section-about-us">
      <div class="container">
        <div class="row">
          <div class="col-md-8 ml-auto mr-auto text-center">
           <!-- <h2 class="title">¿Dónde nos encontramos?</h2>-->
            <h5 class="description">
              En el mapa podrás encontrar todas las seccionales del país. Haciendo click en los pines azules podrás visualizar información de contacto como dirección, números de teléfonos y horarios de atención.
            </h5> 
            <div>
                <mapa></mapa>
            </div>
          </div>
        </div>
        <div class="separator separator-primary"></div>
        <div class="section-story-overview">
          <div class="row">
            <div class="contact-content"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>

import Vue from "vue";
import { Table, TableColumn } from "element-ui";
import { Card, Button, FormGroupInput, Tabs, TabPane, Mapa } from "@/components";

Vue.use(Table);
Vue.use(TableColumn);
export default {
  name: "landing-page",
  bodyClass: "landing-page",
  components: {
    Mapa,
    Card,
    Tabs,
    TabPane,
    [Button.name]: Button,
    [FormGroupInput.name]: FormGroupInput
  },
  data() {
    return {     
        tableData:[],
        firstName: "",
        email: "",
        message: ""
       
    };
  },
  // methods: {
   // tableRowClassName({ row, rowIndex }) {
   //   if (rowIndex % 2 != 0) {
   //     return "table-info";
   //   }
   //   return "";
   // }
  // },
   async created() {
    let res = await this.$osapm().get("misc/getSeccionales");

    //let res = await this.axios.get("mock/seccionales.json");

    this.tableData = res.data;
   }
};
</script>
<style>
</style>
